import React from 'react';
import { useIntl } from 'react-intl';
import { isDev } from '@utils/is-dev';
import styled from 'styled-components';
import * as yup from 'yup';

import Form from '@components/form/form';
import FormTextField from '@components/form/form-text-field';
import ButtonNext from '@domain/button-next';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 24px;
`;

const FormArea = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 30px;
  width: 50vw;
  padding: 36px;
  @media only screen and (max-width: 992px) {
    width: 80vw;
    padding: 24px;
  }
`;

const FormHeader = styled.h1`
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  margin-top: 20px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 768px) {
    font-size: 24px;
    margin-top: 0;
  }
`;

export interface MveFormValues {
  mveNumber: string;
}

const defaultValues: MveFormValues = {
  mveNumber: isDev ? '5SPDKV' : ''
};

interface MveFeatureProps {
  onSubmit: (values: MveFormValues) => Promise<void>;
  isPending?: boolean;
  title?: string;
}

function MveFeature({ onSubmit, isPending, title }: MveFeatureProps) {
  const intl = useIntl();
  const schema = yup.object({
    mveNumber: yup
      .string()
      .required(intl.formatMessage({ id: 'MVE_NUMBER_ERROR' }))
  });

  return (
    <Container>
      <FormArea>
        <Form schema={schema} defaultValues={defaultValues} onSubmit={onSubmit}>
          <FormHeader>
            {title ?? intl.formatMessage({ id: 'MVE_VERIFICATION_HEADER' })}
          </FormHeader>
          <FormTextField
            name="mveNumber"
            label={intl.formatMessage({ id: 'MVE_NUMBER' })}
            type="text"
            autoComplete="off"
            style={{ marginTop: 30 }}
          />
          <ButtonNext
            htmlType="submit"
            fullWidth
            withRightArrow
            isLoading={isPending}
            style={{ marginTop: 30 }}
          />
        </Form>
      </FormArea>
    </Container>
  );
}

export default MveFeature;
